import { Card, Typography } from "antd";
import React from "react";
const { Paragraph } = Typography;

function FacilityAppLinksCard({ user }) {
  const appDomain = `https://${window.location.hostname}`;
  const profileLink = `${appDomain}/calendar?userId=${user._id}&drawer=Facility`;

  return (
    <Card title="Workplace App Links">
      <Paragraph copyable={{ text: profileLink }}>Workplace Profile Link</Paragraph>
      <hr />
    </Card>
  );
}

export { FacilityAppLinksCard };
